export const nominationMap: Record<number, string> = {
  1: 'Территория роста',
  2: 'Технологии партнерства',
  3: 'Педагогический прием',
  4: 'Технологии и инновации',
  5: 'Цифровой педагог',
};
